import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GSTSummary from './GSTSummary';
import GSTInvoice from './GSTInvoice';
import GSTReturn from './GSTReturn';
import GSTPurchase from './GSTPurchase';
import { pillTabsSx } from '../../Global/Styling';

const GST_TABS = [
  { label: 'Summary', value: 0, icon: <AssessmentIcon /> },
  { label: 'GST Invoice', value: 1, icon: <ReceiptLongIcon /> },
  { label: 'GST Purchase', value: 3, icon: <ShoppingCartIcon /> },
  { label: 'GST Return', value: 2, icon: <AssignmentTurnedInIcon /> }
];

export default function GST() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{ ...pillTabsSx, mb: 2 }}>
        {GST_TABS.map((t) => (
          <Tab key={t.value} icon={t.icon} iconPosition="start" label={t.label} value={t.value} />
        ))}
      </Tabs>

      {activeTab === 0 && <GSTSummary />}
      {activeTab === 1 && <GSTInvoice />}
      {activeTab === 2 && <GSTReturn />}
      {activeTab === 3 && <GSTPurchase />}
    </Box>
  );
}
